import { Stack, styled } from '@mui/material';

const FieldWrapper = styled(Stack)`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export default FieldWrapper;
